<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import { Head, Link } from '@inertiajs/vue3';
import PartnerList from '@/Components/PartnerList.vue';
</script>

<script>
export default {
    mounted() {

        // Page view DataLayer event
        if (dataLayer) {
            dataLayer.push({
                event: 'virtualPageView',
                page_type: 'partners',
                site_language: this.$page.props.locale?.toUpperCase() || '?',
                login_status: this.$page.props.user ? 'logged_in' : 'logged_out',
                user_id: this.$page.props.user ? this.$page.props.user.id : null,
            });
        }

    }
}
</script>

<template>

    <Head :title="$t('Partnerség')" />

    <AppLayout>

        <header class="header">
            <div class="header-body header-body-subpage">
                <div class="container">
                    <div class="row align-items-center justify-content-center">
                        <div class="col-12 col-sm-auto col-lg text-center text-sm-right text-lg-left">
                            <h1 class="header-h1">{{ $t('Partnerség') }}</h1>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <div class="header-placeholder"></div>

        <div class="subpage-content">
            <div class="container subpage-container">
                <div class="row">
                    <main class="main col-12">
                        <section>
                            <div class="row section-title d-none">
                                <div class="col-12">
                                    <h2>{{ $t('Partnerség') }}</h2>
                                </div>
                            </div>
                            <div class="row align-items-center">
                                <div class="col-lg-9 col-sm-7">
                                    <p class="mb-3 fs-6" v-html="$t('Ha szeretne csatlakozni a miniBUD üzleti partneri hálózatához, kérjük, kattintson a B2B regisztráció gombra, majd töltse ki a regisztrációs űrlapot. Ezt követően a miniBUD repülőtéri transzfert és a további szolgáltatásokat kedvezménnyel foglalhatja majd.')">
                                    </p>
                                </div>
                                <div class="col-lg-3 col-sm-5 text-center text-md-end">
                                    <Link :href="route('b2bRegistration')" class="btn btn-primary mb-3 text-uppercase">{{ $t('B2B Regisztráció') }}</Link>
                                </div>
                            </div>
                            <hr />
                            <PartnerList />
                        </section>
                    </main>
                </div>
            </div>
        </div>

    </AppLayout>
</template>
